<template>
  <v-container fluid>
    <h1 class="ml-2 title font-weight-medium py-2">หน่วยงาน</h1>
    <v-tabs
      v-model="tab"
      height="42"
      background-color="transparent"
      @change="handleChangeTab"
    >
      <v-tab>ตาราง</v-tab>
      <v-tab class="text-capitalize">โครงสร้าง Tree</v-tab>
    </v-tabs>
    <v-tabs-items v-model="tab">
      <v-tab-item class="blue-grey lighten-4">
        <div class="mt-4 mb-2 d-flex justify-space-between align-center">
          <div class="d-flex align-center">
            <v-text-field
              v-model="search"
              class="white"
              prepend-inner-icon="mdi-magnify"
              clearable
              dense
              outlined
              hide-details
              placeholder="รหัส - ชื่อหน่วยงาน"
              @input="handleSearch"
            ></v-text-field>
            <div
              class="d-flex align-center rounded"
              style="
                width: 260px;
                margin: 0 5px;
                padding: 7px 0;
                cursor: pointer;
                background-color: white;
                border: 1px solid #bdbdbd;
              "
            >
              <span
                class="flex-grow-1 pl-3 text-truncate"
                @click="handleOrganizationsFilter"
              >
                <span
                  v-if="!filterOrganization.organization_uuid"
                  class="grey--text"
                >
                  สังกัดหน่วยงาน
                </span>
                <span v-else>{{ filterOrganization.title_th }}</span>
              </span>
              <v-icon
                v-if="filterOrganization.organization_uuid"
                class="mr-2"
                @click="handleClearOrganizationsFilter"
              >
                mdi-close
              </v-icon>
              <v-icon class="mr-3" @click="handleOrganizationsFilter">
                mdi-tune
              </v-icon>
            </div>
            <v-dialog
              v-model="dialogOrganizationsFilter"
              scrollable
              width="420px"
            >
              <v-card>
                <v-card-title class="pt-0 px-4">
                  <v-text-field
                    v-model="searchOrganizationsFilter"
                    prepend-inner-icon="mdi-magnify"
                    clearable
                    placeholder="รหัส - ชื่อหน่วยงาน"
                    hide-details
                    @input="handleSearchOrganizationsFilter"
                    :loading="loadingOrganizationsFilter"
                  ></v-text-field>
                </v-card-title>
                <v-divider></v-divider>
                <v-card-text style="height: 300px" class="pa-0">
                  <v-list>
                    <v-list-item-group>
                      <v-list-item
                        v-for="organization in organizationsFilter"
                        :key="organization.organization_uuid"
                        @click="handleOrganizationSelected(organization)"
                      >
                        <v-list-item-content>
                          <v-list-item-title>
                            {{ organization.organization_code }} -
                            {{ organization.title_th }}
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                      <p
                        v-if="organizationsFilter.length === 0"
                        class="mt-5 text-center"
                      >
                        {{
                          loadingOrganizationsFilter
                            ? 'กำลังโหลดข้อมูล'
                            : 'ไม่มีข้อมูล'
                        }}
                      </p>
                    </v-list-item-group>
                    <v-list-item-group
                      v-if="
                        organizationsFilter.length > 0 &&
                        organizationsFilter.length < organizationsFilterTotal
                      "
                      v-intersect="onIntersect"
                    ></v-list-item-group>
                  </v-list>
                </v-card-text>
              </v-card>
            </v-dialog>
          </div>
          <div class="d-flex align-center">
            <v-btn
              :disabled="
                uiCtrl && !uiCtrl.isEnable('btn:::organization:create')
              "
              style="margin-top: 1px"
              color="primary"
              @click="handleAddOrganizationForm"
            >
              <v-icon small left>mdi-plus</v-icon>เพิ่มหน่วยงาน
            </v-btn>
            <v-menu min-width="200">
              <template v-slot:activator="{ on, attrs }">
                <v-btn icon v-bind="attrs" v-on="on">
                  <v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>

              <v-list nav dense>
                <v-list-item
                  link
                  :disabled="
                    uiCtrl &&
                    !uiCtrl.isEnable(
                      'btn:::import_data:import_csv:organization:post'
                    )
                  "
                  @click="uploadDialog = true"
                >
                  <v-list-item-icon>
                    <v-icon>mdi-import</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title>นำเข้าข้อมูล</v-list-item-title>
                  </v-list-item-content>
                </v-list-item>
              </v-list>
            </v-menu>
          </div>
        </div>

        <v-data-table
          :sort-by="sortBy"
          :sort-desc="sortDesc"
          :loading="loading"
          loading-text="Loading... Please wait"
          :headers="headers"
          :items="organizations"
          :options.sync="options"
          :server-items-length="totalOrganizations"
          :items-per-page="10"
          class="elevation-1"
          :footer-props="{
            itemsPerPageOptions: [10, 25, 50, 100],
            itemsPerPageText: 'Rows per page:',
          }"
          :item-class="classRowSelected"
          @click:row="handleRowSelected"
        >
          <template v-slot:item.root_organization="{ item }">
            <span v-if="item.root_organization">
              {{ item.root_organization.organization_code }} -
              {{ item.root_organization.title_th }}
            </span>
            <span v-else>-</span>
          </template>
          <template v-slot:item.organization_boss="{ item }">
            <span v-if="item.organization_boss">
              {{ item.organization_boss.firstname_th || '' }}
              {{ item.organization_boss.lastname_th || '' }}
            </span>
            <span v-else>-</span>
          </template>
        </v-data-table>
      </v-tab-item>
      <v-tab-item class="blue-grey lighten-4">
        <div class="white mt-2 py-3 px-4 d-flex align-center">
          <v-btn-toggle v-model="horizontal" dense borderless>
            <v-btn :value="false">แนวนอน</v-btn>
            <v-btn :value="true">แนวตั้ง</v-btn>
          </v-btn-toggle>
          <!-- <v-btn-toggle
            class="ml-2"
            v-model="expand"
            dense
            borderless
            @change="expandChange"
          >
            <v-btn class="text-capitalize" :value="true">Expand</v-btn>
            <v-btn class="text-capitalize" :value="false">Collapse</v-btn>
          </v-btn-toggle>
          <label class="ml-4">
            <input type="checkbox" v-model="collapsable" /> Collapsable
          </label> -->
          <v-checkbox
            v-model="filterBoss"
            class="mt-0 ml-6"
            label="หัวหน้าหน่วยงาน"
            hide-details
          ></v-checkbox>
        </div>
        <v-divider></v-divider>
        <div
          style="
            display: flex;
            width: 100%;
            height: calc(100dvh - 245px);
            background-color: white;
            overflow: scroll;
          "
        >
          <vue2-org-tree
            :data="treeDataOrg"
            :horizontal="horizontal"
            :collapsable="collapsable"
            :label-class-name="labelClassName"
            :render-content="renderContent"
            selected-class-name="selected-class-name"
            selected-key="selectedKey"
            @on-expand="onExpand"
            @on-node-click="onNodeClick"
          />
        </div>
      </v-tab-item>
    </v-tabs-items>
    <OrganizationForm
      :formShow="organizationFormShow"
      :formAction="organizationFormAction"
      :organization="organization"
      :organizationInit="organizationInit"
      @isOrganizationDataChange="handleOrganizationFormDataChange"
      @formActionCompleted="handleOrganizationFormActionCompleted"
      @onReset="handleOrganizationFormReset"
    />
    <ConfirmDialog
      :dialog="confirmDialogDataChange"
      :loading="confirmDialogDataChangeLoading"
      :dialogData="confirmDialogDataChangeData"
      @cancelConfirmDialog="cancelConfirmDialogDataChange"
      @submitConfirmDialog="submitConfirmDialogDataChange"
    />
    <v-overlay
      :value="organizationFormShow && organizationFormAction === 'add'"
      z-index="0"
    ></v-overlay>
    <v-dialog v-model="dialogProgress" persistent width="320">
      <div class="pa-4 white">
        <v-progress-linear :value="progressValue" height="25">
          <strong>{{ Math.ceil(progressValue) }}%</strong>
        </v-progress-linear>
      </div>
    </v-dialog>
    <v-dialog v-model="dialogOrganizationTreeForm" persistent max-width="600px">
      <v-card>
        <v-card-title>
          <span class="text-h5">เพิ่มหน่วยงานใหม่</span>
        </v-card-title>
        <v-card-text>
          <v-container>
            <v-form ref="formOrganizationTree" lazy-validation>
              <v-row>
                <v-col cols="12" class="pa-0">
                  <label class="body-2">
                    รหัสหน่วยงาน
                    <span class="red--text"><strong>*</strong></span>
                  </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="1"
                    v-model="organization.organization_code"
                    :rules="[
                      (v) => !!v || 'โปรดระบุรหัสหน่วยงาน',
                      (v) =>
                        (v && v.length >= 1 && v.length <= 32) ||
                        'รหัสหน่วยงานต้องอยู่ระหว่าง 1 ถึง 32 ตัวอักษร',
                    ]"
                    required
                    clearable
                    @change="checkEmpty($event, 'organization_code')"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <label class="body-2">
                    ชื่อหน่วยงาน
                    <span class="red--text"><strong>*</strong></span>
                  </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="2"
                    v-model="organization.title_th"
                    :rules="[
                      (v) => !!v || 'โปรดระบุชื่อหน่วยงาน',
                      (v) =>
                        !v ||
                        (v && v.length <= 100) ||
                        'ชื่อหน่วยงานต้องน้อยกว่า 100 ตัวอักษร',
                    ]"
                    required
                    clearable
                    @change="checkEmpty($event, 'title_th')"
                    outlined
                    dense
                  >
                  </v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <label class="body-2"> ชื่อหน่วยงาน (อังกฤษ) </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="3"
                    v-model="organization.title_en"
                    :rules="[
                      (v) =>
                        !v ||
                        (v && v.length <= 100) ||
                        'ชื่อหน่วยงานต้องน้อยกว่า 100 ตัวอักษร',
                    ]"
                    clearable
                    @change="checkEmpty($event, 'title_en')"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <label class="body-2"> คำอธิบาย </label>
                  <v-text-field
                    class="fix-google-chrome mt-1"
                    tabindex="4"
                    v-model="organization.description"
                    :rules="[
                      (v) =>
                        !v ||
                        (v && v.length <= 1000) ||
                        'คำอธิบายต้องน้อยกว่า 1000 ตัวอักษร',
                    ]"
                    clearable
                    @change="checkEmpty($event, 'description')"
                    outlined
                    dense
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="pa-0">
                  <div>
                    <label class="body-2">หัวหน้า</label>
                    <v-text-field
                      class="fix-google-chrome mt-1"
                      readonly
                      :value="
                        organization.organizationBoss
                          ? `${organization.organizationBoss.firstname_th} ${organization.organizationBoss.lastname_th}`
                          : ''
                      "
                      outlined
                      dense
                    >
                      <template v-slot:append>
                        <v-btn
                          v-if="organization.organizationBoss"
                          class="mb-2"
                          icon
                          @click="handleDeleteOrganizationBoss"
                        >
                          <v-icon>mdi-delete</v-icon>
                        </v-btn>
                        <v-btn
                          v-else
                          class="mb-2"
                          icon
                          @click="addOrganizationBoss"
                        >
                          <v-icon>mdi-plus</v-icon>
                        </v-btn>
                      </template>
                    </v-text-field>
                  </div>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="blue darken-1"
            text
            :loading="loadingOrganizationTreeForm"
            @click="handleAddOrganizationTree"
          >
            ตกลง
          </v-btn>
          <v-btn
            text
            :disabled="loadingOrganizationTreeForm"
            @click="handleCancelOrganizationTreeForm"
            >ยกเลิก</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <UploadDialog
      :uploadDialog="uploadDialog"
      uploadDialogTitle="นำเข้าข้อมูลโครงสร้างองค์กร"
      :downloadExampleFileImportDataUrl="exampleFileImportDataUrl"
      downloadExampleFileImportDataName="organization.csv"
      @selectedFile="selectedFile"
      @handleCancelUploadDialog="handleCancelUploadDialog"
      @uploadFile="uploadFile"
    />
    <UploadDialogMessage
      :uploadDialogMessage="uploadDialogMessage"
      uploadDialogMessageTitle="นำเข้าข้อมูลโครงสร้างองค์กรไม่สำเร็จ"
      :downloadFileImportDataUrl="fileImportDataUrl"
      :downloadFileImportDataName="fileImportDataName"
      @onClose="uploadDialogMessage = false"
    />
    <EmployeeListDialog
      :dialog="employeeListDialog"
      @cancelEmployeeListDialog="cancelEmployeeListDialog"
      @submitEmployeeListDialog="submitEmployeeListDialog"
    />
    <ForbiddenDialog
      :dialog="dialogForbidden"
      @onCloseDialog="dialogForbidden = false"
    />
  </v-container>
</template>

<script>
import _ from 'lodash'
import { mapActions } from 'vuex'

// @ is an alias to /src
import ConfirmDialog from '@/components/ConfirmDialog.vue'
import EmployeeListDialog from '@/components/EmployeeListDialog.vue'
import UploadDialog from '@/components/UploadDialog.vue'
import UploadDialogMessage from '@/components/UploadDialogMessage.vue'
import OrganizationForm from '@/views/organization/OrganizationForm.vue'

export default {
  components: {
    OrganizationForm,
    ConfirmDialog,
    UploadDialog,
    UploadDialogMessage,
    EmployeeListDialog,
  },
  data() {
    return {
      employeeListDialog: false,
      filterBoss: true,
      dialogOrganizationTreeForm: false,
      selectedOrganizationTreeNode: null,
      loadingOrganizationTreeForm: false,
      tab: 0,
      expand: true,
      horizontal: true,
      collapsable: false,
      treeDataOrg: {},
      viewLayout: 'table',
      dialogForbidden: false,
      fileImportDataUrl: '',
      fileImportDataName: '',
      dialogProgress: false,
      progressValue: 0,
      dialogOrganizationsFilter: false,
      organizationsFilter: [],
      organizationsFilterTotal: 0,
      organizationsFilterPage: 1,
      searchOrganizationsFilter: '',
      loadingOrganizationsFilter: false,
      filterOrganization: {},
      loading: false,
      options: {},
      sortBy: ['organization_code'],
      sortDesc: [false],
      search: '',
      currentFile: null,
      uploadDialog: false,
      uploadDialogMessage: false,
      confirmDialogDataChange: false,
      confirmDialogDataChangeLoading: false,
      confirmDialogDataChangeData: {},
      organizationFormShow: false,
      organizationFormAction: '',
      organization: {},
      organizationInit: {},
      isOrganizationDataChange: false,
      interval: null,
      timeout: null,
      headers: [
        {
          text: 'รหัสหน่วยงาน',
          align: 'start',
          value: 'organization_code',
          width: 150,
        },
        { text: 'ชื่อหน่วยงาน', value: 'title_th' },
        { text: 'ชื่อหน่วยงาน (อังกฤษ)', value: 'title_en' },
        {
          text: 'สังกัดหน่วยงาน',
          value: 'root_organization',
        },
        { text: 'หัวหน้าหน่วยงาน', value: 'organization_boss' },
      ],
    }
  },
  watch: {
    options: {
      handler() {
        this.getOrganizations()
      },
      deep: true,
    },
  },
  computed: {
    uiCtrl() {
      return this.$store.state.uiCtrl
    },
    organizations() {
      return this.$store.state.organization.organizations
    },
    totalOrganizations() {
      return this.$store.state.organization.totalOrganizations
    },
    exampleFileImportDataUrl() {
      return this.$store.state.download.exampleFileImportDataUrl
    },
  },
  created() {
    this.$store.commit('SET_BREADCRUMBS', [
      { text: 'หน้าหลัก', disabled: false, to: '/' },
      {
        text: 'โครงสร้างองค์กร',
        disabled: true,
      },
    ])

    this.getExampleFileImportData()
    const { company_uuid } = this.$store.state.authentication.company

    this.fetchOrganizationsAll({
      company_uuid,
      params: {
        dpc: 'organization-to-list-organization',
        field: 'organization_uuid,organization_code,title_th',
      },
    }).catch((error) => {
      const snackbar = {
        show: true,
        color: 'error',
        timeout: -1,
        message: error?.response?.data?.message || 'Something went wrong!',
      }
      this.$store.commit('SET_SNACKBAR', snackbar)
    })
  },
  methods: {
    ...mapActions({
      fetchOrganization: 'organization/fetchOrganization',
      fetchOrganizationsAll: 'organization/fetchOrganizationsAll',
      fetchOrganizationsAuthorizedTree:
        'organization/fetchOrganizationsAuthorizedTree',
      fetchOrganizationsFilter: 'organization/fetchOrganizationsFilter',
      fetchOrganizations: 'organization/fetchOrganizations',
      fetchOrganizationBoss: 'organization/fetchOrganizationBoss',
      fetchEmployee: 'employee/fetchEmployee',
      uploadFileImportData: 'upload/uploadFileImportData',
      downloadExampleFileImportData: 'download/downloadExampleFileImportData',
      generateFileProgress: 'download/generateFileProgress',
      addOrganization: 'organization/addOrganization',
      editOrganizationBoss: 'organization/editOrganizationBoss',
    }),
    handleDeleteOrganizationBoss() {
      this.organization = {
        ...this.organization,
        organizationBoss: null,
      }
    },
    addOrganizationBoss() {
      this.employeeListDialog = true
    },
    cancelEmployeeListDialog() {
      this.employeeListDialog = false
    },
    submitEmployeeListDialog(selectedItems) {
      this.organization = {
        ...this.organization,
        organizationBoss: {
          employee_code: selectedItems[0].employee_code,
          employee_uuid: selectedItems[0].employee_uuid,
          firstname_th: selectedItems[0].firstname_th,
          lastname_th: selectedItems[0].lastname_th,
          firstname_en: selectedItems[0].firstname_en,
          lastname_en: selectedItems[0].lastname_en,
        },
      }

      this.employeeListDialog = false
    },
    checkEmpty(value, field) {
      if (value) {
        this.organization[field] = value.trim()
      }
    },
    async handleChangeTab() {
      if (this.tab === 1) {
        try {
          // if (!_.isEmpty(this.treeDataOrg)) return

          const { company_uuid } = this.$store.state.authentication.company

          this.$store.state.loading = true

          const response = await this.fetchOrganizationsAuthorizedTree({
            company_uuid,
          })

          this.treeDataOrg = this.mapOrgTree(response[0])
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.$store.state.loading = false
        }
      }
    },
    mapOrgTree: function (node) {
      if (!node) return null

      return {
        ...node,
        id: node.organization_uuid,
        label: `${node.organization_code} - ${node.title_th}`,
        expand: this.expand,
        children: node.children
          ? node.children.map((child) => this.mapOrgTree(child))
          : [],
      }
    },
    labelClassName: function (data) {
      return 'clickable-node'
    },
    renderContent: function (h, data) {
      const bossElement = this.filterBoss
        ? h(
            'span',
            {
              style: {
                marginTop: '2px',
              },
            },
            `หัวหน้า: ${data.organization_boss?.firstname_th} ${data.organization_boss?.lastname_th}`
          )
        : null

      return h('div', [
        h(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
            },
          },
          [
            h('span', data.label),
            h(
              'button',
              {
                style: {
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  width: '28px',
                  height: '28px',
                  borderRadius: '50%',
                  border: '1px solid #ccc',
                  background: '#fff',
                  cursor: 'pointer',
                  marginLeft: '5px',
                },
                on: {
                  click: (e) => {
                    e.stopPropagation()
                    this.onAddOrganizationTree(data)
                  },
                },
              },
              [
                h(
                  'svg',
                  {
                    attrs: {
                      xmlns: 'http://www.w3.org/2000/svg',
                      width: '14',
                      height: '14',
                      viewBox: '0 0 24 24',
                      fill: 'none',
                      stroke: 'currentColor',
                      'stroke-width': '2',
                      'stroke-linecap': 'round',
                      'stroke-linejoin': 'round',
                    },
                  },
                  [
                    h('line', {
                      attrs: { x1: '12', y1: '5', x2: '12', y2: '19' },
                    }),
                    h('line', {
                      attrs: { x1: '5', y1: '12', x2: '19', y2: '12' },
                    }),
                  ]
                ),
              ]
            ),
          ]
        ),
        h(
          'div',
          {
            style: {
              display: 'flex',
              alignItems: 'center',
              gap: '6px',
              fontSize: '14px',
              color: '#666',
            },
          },
          [data.organization_boss ? bossElement : null]
        ),
      ])
    },
    onAddOrganizationTree(node) {
      this.organization = {}
      this.organizationInit = {}

      this.dialogOrganizationTreeForm = true
      this.selectedOrganizationTreeNode = node
    },
    handleCancelOrganizationTreeForm() {
      this.dialogOrganizationTreeForm = false
      this.selectedOrganizationTreeNode = null

      this.$refs.formOrganizationTree.resetValidation()
      this.organization = {}
    },
    async handleAddOrganizationTree() {
      if (this.$refs.formOrganizationTree.validate()) {
        try {
          const { company_uuid } = this.$store.state.authentication.company

          this.loadingOrganizationTreeForm = true

          const response = await this.addOrganization({
            company_uuid,
            organization: {
              ...this.organization,
              root_organization_uuid:
                this.selectedOrganizationTreeNode.organization_uuid,
            },
          })

          if (this.organization.organizationBoss) {
            await this.editOrganizationBoss({
              company_uuid,
              organization_uuid: response.organization_uuid,
              employee_uuid: this.organization.organizationBoss.employee_uuid,
            })
          }

          if (!this.selectedOrganizationTreeNode.children)
            this.$set(this.selectedOrganizationTreeNode, 'children', [])
          this.selectedOrganizationTreeNode.expand = true
          this.selectedOrganizationTreeNode.children.unshift({
            ...response,
            organization_boss: this.organization.organizationBoss,
            id: response.organization_uuid,
            label: `${response.organization_code} - ${response.title_th}`,
            expand: true,
          })
        } catch (error) {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        } finally {
          this.loadingOrganizationTreeForm = false
          this.dialogOrganizationTreeForm = false
          this.selectedOrganizationTreeNode = null
          this.$refs.formOrganizationTree.resetValidation()
          this.organization = {}
        }
      }
    },
    onDeleteOrg(target, parent) {
      if (!parent || !parent.children) return

      const idx = parent.children.findIndex((c) => c.id === target.id)
      if (idx !== -1) {
        parent.children.splice(idx, 1)
        return
      }

      // recursive down children
      parent.children.forEach((c) => this.onDeleteOrg(target, c))
    },
    onExpand: function (e, data) {
      if ('expand' in data) {
        data.expand = !data.expand

        if (!data.expand && data.children) {
          this.collapse(data.children)
        }
      } else {
        this.$set(data, 'expand', true)
      }
    },
    onNodeClick: function (e, data) {
      this.$set(data, 'selectedKey', !data.selectedKey)
    },
    collapse: function (list) {
      var _this = this
      list.forEach(function (child) {
        if (child.expand) {
          child.expand = false
        }

        child.children && _this.collapse(child.children)
      })
    },
    expandChange: function () {
      this.toggleExpand(this.treeDataOrg, this.expand)
    },
    toggleExpand: function (data, val) {
      var _this = this
      if (Array.isArray(data)) {
        data.forEach(function (item) {
          _this.$set(item, 'expand', val)
          if (item.children) {
            _this.toggleExpand(item.children, val)
          }
        })
      } else {
        this.$set(data, 'expand', val)
        if (data.children) {
          _this.toggleExpand(data.children, val)
        }
      }
    },
    handleClearOrganizationsFilter() {
      this.filterOrganization = {}
      this.options.page = 1
      this.getOrganizations()
    },
    handleOrganizationSelected(organization) {
      this.dialogOrganizationsFilter = false
      this.filterOrganization = { ...organization }
      this.options.page = 1
      this.getOrganizations()
    },
    handleSearchOrganizationsFilter() {
      this.loadingOrganizationsFilter = true
      this.getOrganizationsFilterBySearch()
    },
    getOrganizationsFilterBySearch: _.debounce(async function () {
      this.organizationsFilterPage = 1

      const { total, organizations } = await this.getOrganizationsFilter()

      this.organizationsFilter = [...organizations]
      this.organizationsFilterTotal = total
    }, 1000),
    async onIntersect(entries, observer, isIntersecting) {
      if (isIntersecting) {
        this.organizationsFilterPage += 1

        const { total, organizations } = await this.getOrganizationsFilter()

        this.organizationsFilter = [
          ...this.organizationsFilter,
          ...organizations,
        ]
        this.organizationsFilterTotal = total
      }
    },
    handleSearch() {
      this.loading = true
      this.getOrganizationsBySearch()
    },
    getOrganizationsBySearch: _.debounce(function () {
      this.options.page = 1
      this.getOrganizations()
    }, 1000),
    selectedFile(file) {
      this.currentFile = file
    },
    handleCancelUploadDialog(refs) {
      this.uploadDialog = false
      this.currentFile = null
      refs.clearableCallback()
    },
    uploadFile(refs) {
      if (this.currentFile) {
        let formData = new FormData()
        formData.append('file', this.currentFile)

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          uuid: company_uuid,
          fileType: 'organization',
          formData: formData,
        }

        this.$store.state.loading = true

        this.uploadFileImportData(payload)
          .then((data) => {
            this.$store.state.loading = false
            this.uploadDialog = false
            refs.clearableCallback()

            this.progressValue = 0
            this.dialogProgress = true
            this.uploadProgress(data.job_process_uuid, data.ping_after_ms)
          })
          .catch((error) => {
            this.$store.state.loading = false
            this.uploadDialog = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)
          })
      } else {
        const snackbar = {
          show: true,
          color: 'warning',
          timeout: 4000,
          message: 'ไม่ได้เลือกไฟล์ใด',
        }

        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    uploadProgress(job_process_uuid, ping_after_ms) {
      this.interval = setInterval(() => {
        this.generateFileProgress(job_process_uuid)
          .then((res) => {
            if (res.is_success) {
              this.progressValue = 100
              this.timeout = setTimeout(() => {
                this.dialogProgress = false
              }, 200)

              clearInterval(this.interval)

              if (res.resource_json?.total_fail > 0) {
                const fileUrl = res.resource_uri
                const fileName = fileUrl.split('/').pop()
                this.fileImportDataUrl = fileUrl
                this.fileImportDataName = fileName
                this.timeout = setTimeout(() => {
                  this.uploadDialogMessage = true
                }, 300)
              } else {
                this.getOrganizations()

                this.timeout = setTimeout(() => {
                  const snackbar = {
                    show: true,
                    color: 'success',
                    timeout: 3000,
                    message: 'นำเข้าข้อมูลสำเร็จ',
                  }

                  this.$store.commit('SET_SNACKBAR', snackbar)
                }, 300)
              }
            } else {
              this.progressValue = (100 / res.total) * res.progress
            }
          })
          .catch((error) => {
            clearInterval(this.interval)
            this.dialogProgress = false

            const snackbar = {
              show: true,
              color: 'error',
              timeout: -1,
              message:
                error?.response?.data?.message || 'Something went wrong!',
            }
            this.$store.commit('SET_SNACKBAR', snackbar)

            clearInterval(this.interval)
          })
      }, ping_after_ms)
    },
    classRowSelected(row) {
      if (this.organization.organization_uuid === row.organization_uuid)
        return 'row-selected'
    },
    async setDataRowSelected(row) {
      if (this.uiCtrl && !this.uiCtrl.isEnable('row:::organization:get')) {
        this.dialogForbidden = true
        return
      }

      try {
        await this.fetchOrganization({
          company_uuid: this.$store.state.authentication.company.company_uuid,
          organization_uuid: row.organization_uuid,
        })
      } catch (error) {
        if (error.response && error.response.status === 403) {
          this.dialogForbidden = true
        } else {
          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        }

        return
      }

      if (this.organization.organization_uuid === row.organization_uuid) {
        this.organizationFormShow = false
        this.organizationFormAction = ''
        this.organization = {}
        this.organizationInit = {}
        return
      }

      try {
        this.$store.state.loading = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          organization_uuid: row.organization_uuid,
        }

        const organizationBoss = await this.fetchOrganizationBoss(payload)

        if (organizationBoss.length > 0) {
          const payload = {
            company_uuid,
            employee_uuid: organizationBoss[0].employee_uuid,
            params: {
              dpc: 'organization-to-get-employee-no-filter',
            },
          }

          const employee = await this.fetchEmployee(payload)

          row.organizationBoss = {
            employee_uuid: employee.employee_uuid,
            fullname: `${employee.firstname_th} ${employee.lastname_th}`,
          }

          row.root_organization_uuid = row.root_organization
            ? row.root_organization.organization_uuid
            : null

          this.organizationFormShow = true
          this.organizationFormAction = 'edit'
          this.organization = { ...row }
          this.organizationInit = { ...row }

          this.$store.state.loading = false
        } else {
          row.organizationBoss = null

          row.root_organization_uuid = row.root_organization
            ? row.root_organization.organization_uuid
            : null

          this.organizationFormShow = true
          this.organizationFormAction = 'edit'
          this.organization = { ...row }
          this.organizationInit = { ...row }

          this.$store.state.loading = false
        }
      } catch (error) {
        this.$store.state.loading = false

        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      }
    },
    handleRowSelected(row) {
      if (this.isOrganizationDataChange) {
        this.confirmDialogDataChangeData = {
          title: 'ต้องการปิดใช่ไหม',
          text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการปิดโดยที่ยังไม่บันทึกข้อมูล',
          value: '',
          item: {
            type: 'row',
            data: row,
          },
        }
        this.confirmDialogDataChange = true
      } else {
        this.setDataRowSelected(row)
      }
    },
    handleAddOrganizationForm() {
      this.organizationFormShow = true
      this.organizationFormAction = 'add'
      this.organization = {
        organizationBoss: null,
      }
      this.organizationInit = {
        organizationBoss: null,
      }
    },
    handleOrganizationFormDataChange(value) {
      this.isOrganizationDataChange = value
    },
    handleOrganizationFormReset(formAction) {
      if (formAction === 'edit')
        this.organization = { ...this.organizationInit }
    },
    handleOrganizationFormActionCompleted(formAction) {
      this.organization = {}
      this.organizationInit = {}
      this.organizationFormShow = false
    },
    async handleOrganizationsFilter() {
      this.dialogOrganizationsFilter = true
      this.organizationsFilterPage = 1

      const { total, organizations } = await this.getOrganizationsFilter()

      this.organizationsFilter = [...organizations]
      this.organizationsFilterTotal = total
    },
    async getOrganizationsFilter() {
      try {
        this.loadingOrganizationsFilter = true

        const { company_uuid } = this.$store.state.authentication.company

        const payload = {
          company_uuid,
          params: {
            dpc: 'organization-to-list-organization',
            search: this.searchOrganizationsFilter || undefined,
            sort: 'organization_code:asc',
            field: 'organization_uuid,organization_code,title_th',
            limit: 10,
            offset: (this.organizationsFilterPage - 1) * 10,
          },
        }

        const response = await this.fetchOrganizationsFilter(payload)

        return response
      } catch (error) {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      } finally {
        this.loadingOrganizationsFilter = false
      }
    },
    getOrganizations() {
      this.loading = true

      const { sortBy, sortDesc, page, itemsPerPage } = this.options

      const sortParams = sortBy
        .map((field, i) => `${field}:${sortDesc[i] ? 'desc' : 'asc'}`)
        .join(',')

      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        company_uuid,
        params: {
          dpc: 'organization-to-list-organization',
          search: this.search || undefined,
          root_organization_uuid:
            this.filterOrganization.organization_uuid || undefined,
          sort: sortParams || undefined,
          limit: itemsPerPage,
          offset: (page - 1) * itemsPerPage,
        },
      }

      this.fetchOrganizations(payload)
        .then(() => {
          this.loading = false
        })
        .catch((error) => {
          this.loading = false

          const snackbar = {
            show: true,
            color: 'error',
            timeout: -1,
            message: error?.response?.data?.message || 'Something went wrong!',
          }
          this.$store.commit('SET_SNACKBAR', snackbar)
        })
    },
    getExampleFileImportData() {
      const { company_uuid } = this.$store.state.authentication.company

      const payload = {
        uuid: company_uuid,
        exampleFileType: 'organization',
      }

      this.downloadExampleFileImportData(payload).catch((error) => {
        const snackbar = {
          show: true,
          color: 'error',
          timeout: -1,
          message: error?.response?.data?.message || 'Something went wrong!',
        }
        this.$store.commit('SET_SNACKBAR', snackbar)
      })
    },
    cancelConfirmDialogDataChange() {
      this.confirmDialogDataChange = false
    },
    submitConfirmDialogDataChange(item) {
      if (item.type === 'row') {
        this.confirmDialogDataChange = false
        this.setDataRowSelected(item.data)
      } else {
        this.confirmDialogDataChange = false
        this.nextRoute(item.data)
      }
    },
    nextRoute(next) {
      this.organizationFormShow = false

      this.timeout = setTimeout(() => {
        next()
      }, 200)
    },
  },
  beforeRouteLeave(to, from, next) {
    if (this.isOrganizationDataChange) {
      this.confirmDialogDataChangeData = {
        title: 'ต้องการออกจากหน้านี้ใช่ไหม',
        text: 'คุณยังไม่ได้บันทึกข้อมูลของคุณ คุณแน่ใจหรือไม่ว่าต้องการออกโดยที่ยังไม่บันทึกข้อมูล',
        value: '',
        item: {
          type: 'next',
          data: next,
        },
      }
      this.confirmDialogDataChange = true
    } else {
      this.nextRoute(next)
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeout)
  },
}
</script>

<style>
.org-tree-node-label {
  white-space: nowrap;
}

.org-tree-node-label-inner {
  border: 1.5px solid #bdbdbd;
}

.org-tree-node:not(:first-child):before,
.org-tree-node:not(:last-child):after {
  border-top: 1.5px solid #bdbdbd;
}
.org-tree-node:after {
  border-left: 1.5px solid #bdbdbd;
}
.org-tree-node-children:before {
  border-left: 1.5px solid #bdbdbd;
}

.horizontal .org-tree-node-children:before {
  border-top: 1.5px solid #bdbdbd;
}
.horizontal .org-tree-node:only-child:before {
  border-bottom: 1.5px solid #bdbdbd;
}
.horizontal > .org-tree-node:only-child:before {
  border-bottom: 0;
}
.horizontal .org-tree-node:not(:last-child):after {
  border-top: 1.5px solid #bdbdbd;
  border-left: 1.5px solid #bdbdbd;
}
.horizontal .org-tree-node:not(:first-child):before {
  border-left: 1.5px solid #bdbdbd;
}
.horizontal .org-tree-node:not(:only-child):after {
  border-top: 1.5px solid #bdbdbd;
}

.selected-class-name {
  background-color: #eeeeee;
}
.clickable-node {
  cursor: pointer;
}
</style>
